class ProductUpsell {
  constructor() {
    this.init();
  }

  init() {
    const upsellWrapper = document.querySelector('.upsell-products-wrapper');
    if (!upsellWrapper) return;
    
    this.setupUpsellCheckboxes();
    this.setupQuantitySelectors();
    this.initializeQuantityInputs();
    this.modifyAddToCartForm();
  }

  setupUpsellCheckboxes() {
    const upsellCheckboxes = document.querySelectorAll('.upsell-checkbox');
    const upsellItems = document.querySelectorAll('.upsell-product-item');
    
    upsellCheckboxes.forEach(checkbox => {
      checkbox.addEventListener('change', (e) => {
        this.handleUpsellSelection(e.target);
      });
    });

    upsellItems.forEach(item => {
      item.addEventListener('click', (e) => {
        const target = e.target instanceof Element ? e.target : null;
        if (!target) return;

        if (target.classList.contains('upsell-checkbox') || 
            target.closest('.upsell-quantity-selector') ||
            target.closest('quantity-input')) {
          return;
        }
        
        const checkbox = item.querySelector('.upsell-checkbox');
        if (checkbox) {
          checkbox.checked = !checkbox.checked;
          this.handleUpsellSelection(checkbox);
        }
      });
    });
  }

  setupQuantitySelectors() {
    const quantityButtons = document.querySelectorAll('.upsell-quantity-selector .quantity__button');
    const quantityInputs = document.querySelectorAll('.upsell-quantity-selector .quantity-input');
    
    quantityButtons.forEach(button => {
      button.addEventListener('click', (e) => {
        e.stopPropagation();
        
        setTimeout(() => {
          const productItem = button.closest('.upsell-product-item');
          const checkbox = productItem.querySelector('.upsell-checkbox');
          
          if (!checkbox.checked) {
            checkbox.checked = true;
            this.handleUpsellSelection(checkbox);
          } else {
            this.updateTotalPrice();
          }
        }, 10);
      });
    });
    
    quantityInputs.forEach(input => {
      input.addEventListener('change', (e) => {
        e.stopPropagation();
        
        const productItem = input.closest('.upsell-product-item');
        const checkbox = productItem.querySelector('.upsell-checkbox');
        
        if (!checkbox.checked) {
          checkbox.checked = true;
          this.handleUpsellSelection(checkbox);
        } else {
          this.updateTotalPrice();
        }
      });
      
      input.addEventListener('click', (e) => {
        e.stopPropagation();
      });
    });
  }

  initializeQuantityInputs() {
    const quantityInputs = document.querySelectorAll('.upsell-quantity-selector quantity-input');
    quantityInputs.forEach(quantityInput => {
      if (!quantityInput.hasAttribute('data-initialized')) {
        if (typeof QuantityInput !== 'undefined') {
          quantityInput.setAttribute('data-initialized', 'true');
        }
      }
    });
  }

  handleUpsellSelection(checkbox) {
    const productItem = checkbox.closest('.upsell-product-item');
    
    if (checkbox.checked) {
      productItem.classList.add('selected');
    } else {
      productItem.classList.remove('selected');
    }
    
    this.updateTotalPrice();
  }

  updateTotalPrice() {
    const selectedCheckboxes = document.querySelectorAll('.upsell-checkbox:checked');
    const totalPriceElement = document.querySelector('.upsell-total-price');
    const totalAmountElement = document.querySelector('.upsell-total-amount');
    
    if (!totalPriceElement || !totalAmountElement) return;
    
    let totalPrice = 0;
    
    selectedCheckboxes.forEach(checkbox => {
      const price = parseFloat(checkbox.dataset.price);
      const productItem = checkbox.closest('.upsell-product-item');
      const quantityInput = productItem.querySelector('.quantity-input');
      const quantity = parseInt(quantityInput?.value) || 1;
      
      if (!isNaN(price)) {
        totalPrice += price * quantity;
      }
    });
    
    if (selectedCheckboxes.length > 0) {
      totalAmountElement.textContent = this.formatMoney(totalPrice);
      totalPriceElement.style.opacity = '1';
    } else {
      totalPriceElement.style.opacity = '0';
    }
  }

  formatMoney(cents) {
    if (typeof Shopify !== 'undefined' && Shopify.formatMoney) {
      return Shopify.formatMoney(cents, window.theme?.moneyFormat || '${{amount}}');
    }
    
    const dollars = (cents / 100).toFixed(2);
    return `$${dollars}`;
  }

  modifyAddToCartForm() {
    const addToCartForms = document.querySelectorAll('form[data-type="add-to-cart-form"], form[id^="sticky-addcart-form-"], form.feature-product-form');
    const submitButtons = document.querySelectorAll('.product_submit_button');
    
    if (addToCartForms.length === 0 || submitButtons.length === 0) return;

    addToCartForms.forEach((addToCartForm) => {
      const formSubmitButtons = addToCartForm.querySelectorAll('.product_submit_button');
      
      formSubmitButtons.forEach((submitButton) => {
        const buttonLabel = submitButton.querySelector('.btn-label');
        
        if (buttonLabel && !buttonLabel.dataset.originalText) {
          buttonLabel.dataset.originalText = buttonLabel.textContent.trim();
        }

        if (submitButton.hasAttribute('data-upsell-listener-added')) {
          return;
        }

        submitButton.setAttribute('data-upsell-listener-added', 'true');

        const handleFormSubmit = (e) => {
          if (submitButton.hasAttribute('data-processing') || addToCartForm.hasAttribute('data-upsell-handled')) {
            e.preventDefault();
            e.stopPropagation();
            e.stopImmediatePropagation();
            return false;
          }

          const selectedUpsells = this.getSelectedUpsells();
          const hasFreeGift = this.hasFreeGift();
          
          // Intercept if upsells or free gifts are selected
          if (hasFreeGift || selectedUpsells.length > 0) {
            e.preventDefault();
            e.stopPropagation();
            e.stopImmediatePropagation();
            
            submitButton.setAttribute('data-processing', 'true');
            addToCartForm.setAttribute('data-upsell-handled', 'true');
            
            setTimeout(() => {
              this.addProductsToCart(selectedUpsells, submitButton).finally(() => {
                submitButton.removeAttribute('data-processing');
                addToCartForm.removeAttribute('data-upsell-handled');
              });
            }, 0);
            
            return false;
          }
        };

        submitButton.addEventListener('click', handleFormSubmit, { capture: true, passive: false });
        addToCartForm.addEventListener('submit', handleFormSubmit, { capture: true, passive: false });
        submitButton.addEventListener('click', (e) => {
          if (addToCartForm.hasAttribute('data-upsell-handled')) {
            e.preventDefault();
            e.stopPropagation();
            e.stopImmediatePropagation();
            return false;
          }
        }, false);

        addToCartForm.addEventListener('submit', (e) => {
          if (addToCartForm.hasAttribute('data-upsell-handled')) {
            e.preventDefault();
            e.stopPropagation();
            e.stopImmediatePropagation();
            return false;
          }
        }, false);
      });
    });
  }

  getSelectedUpsells() {
    const selectedCheckboxes = document.querySelectorAll('.upsell-checkbox:checked');
    const upsells = [];
    
    selectedCheckboxes.forEach(checkbox => {
      const productItem = checkbox.closest('.upsell-product-item');
      const quantityInput = productItem.querySelector('.quantity-input');
      const quantity = parseInt(quantityInput?.value) || 1;
      
      upsells.push({
        id: parseInt(checkbox.dataset.variantId),
        quantity: quantity
      });
    });
    
    return upsells;
  }

  async addProductsToCart(upsells, submitButton = null) {
    const mainProductForm = document.querySelector('form[data-type="add-to-cart-form"]') || document.querySelector('form[id^="sticky-addcart-form-"]') || document.querySelector('form.feature-product-form');
    if (!mainProductForm) return;
    
    const mainProductData = new FormData(mainProductForm);
    if (!submitButton) {
      submitButton = mainProductForm.querySelector('.product_submit_button');
    }
    
    if (!submitButton) return;
    
    const buttonLabel = submitButton.querySelector('.btn-label');
    const loadingIcon = submitButton.querySelector('.icon-load');
    
    if (!buttonLabel) return;
    
    if (!buttonLabel.dataset.originalText) {
      buttonLabel.dataset.originalText = buttonLabel.textContent.trim();
    }
    
    const loadingText = window.variantStrings?.addingToCart || window.variantStrings?.addToCart || 'Adding to cart...';
    
            submitButton.disabled = true;
      if (loadingIcon) loadingIcon.style.opacity = '1';
      if (buttonLabel) buttonLabel.textContent = loadingText;

    try {
      const items = [];
      
      // Add main product
      const mainProductId = mainProductData.get('id');
      const mainProductQuantity = mainProductData.get('quantity') || '1';
      
      items.push({
        id: parseInt(mainProductId),
        quantity: parseInt(mainProductQuantity)
      });
      
      // Add selected upsells
      upsells.forEach(upsell => {
        items.push(upsell);
      });

      // Add free gifts if available
      const freeGiftsData = this.getFreeGiftData();
      if (freeGiftsData && freeGiftsData.length > 0) {
        freeGiftsData.forEach(gift => {
          items.push({
            id: gift.variantId,
            quantity: 1,
            properties: {
              '_free_gift': 'true'
            }
          });
        });
      }

      const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      
      const requestData = { 
        items: items
      };
      
      if (cart) {
        requestData.sections = cart.getSectionsToRender().map((section) => section.id);
        requestData.sections_url = window.location.pathname;
      }

      // Trigger analytics events
      this.triggerAddToCartEvent(items);

      // Add all items to cart in single request
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify(requestData)
      });

      if (!response.ok) {
        throw new Error('Failed to add products to cart');
      }

      const result = await response.json();
      
      this.updateCartAndOpenDrawer(cart, result);
      this.resetButtonState(submitButton, loadingIcon, buttonLabel);

    } catch (error) {
      console.error('Error adding products to cart:', error);
      
      this.showError('无法添加产品到购物车，请重试');
      this.resetButtonState(submitButton, loadingIcon, buttonLabel);
    }
  }

  updateCartAndOpenDrawer(cart, result) {
    if (cart && result.sections) {
      // Update cart content
      cart.getSectionsToRender().forEach((section) => {
        const elementToReplace = document.getElementById(section.id);
        const html = new DOMParser().parseFromString(
          result.sections[section.id],
          'text/html'
        );
        
        if (elementToReplace) {
          elementToReplace.innerHTML = html.querySelector('#minicart-form').innerHTML;
        }
      });
      
      if (cart && typeof cart.cartAction === 'function') {
        cart.cartAction();
      }
      
      cart.open();
    } else {
      const cartDrawer = document.querySelector('cart-drawer');
      if (cartDrawer && typeof cartDrawer.open === 'function') {
        cartDrawer.open();
      }
    }
  }

  resetButtonState(submitButton, loadingIcon, buttonLabel) {
    submitButton.disabled = false;
    if (loadingIcon) loadingIcon.style.opacity = '0';
    if (buttonLabel) {
      const originalText = buttonLabel.dataset.originalText || window.variantStrings?.addToCart || 'Add to cart';
      buttonLabel.textContent = originalText;
    }
  }

  // Trigger unified analytics events for all tracking platforms
  triggerAddToCartEvent(items) {
    const mainProduct = items[0];
    
    const productForm = document.querySelector('form[data-type="add-to-cart-form"]');
    const productTitle = document.querySelector('.product-detail__title')?.textContent?.trim() || '';
    const productPrice = document.querySelector('.price__regular .price-item--regular')?.textContent?.replace(/[^\d.]/g, '') || '0';
    
    let totalQuantity = 0;
    let totalValue = 0;
    
    const itemsData = items.map(item => {
      totalQuantity += item.quantity;
      
      let itemPrice = 0;
      let itemName = '';
      
      if (item.id === mainProduct.id) {
        const priceInCents = parseFloat(productPrice) * 100 || 0;
        itemPrice = priceInCents;
        itemName = productTitle;
      } else {
        const upsellItem = document.querySelector(`[data-variant-id="${item.id}"]`);
        if (upsellItem) {
          const priceData = upsellItem.dataset.price;
          itemPrice = parseFloat(priceData) || 0;
          
          const titleElement = upsellItem.closest('.upsell-product-item')?.querySelector('.upsell-product-title');
          itemName = titleElement?.textContent?.trim() || '';
        }
      }
      
      totalValue += itemPrice * item.quantity;
      
      return {
        item_id: item.id.toString(),
        item_name: itemName,
        quantity: item.quantity,
        price: itemPrice / 100,
        category: 'product'
      };
    });

          const totalValueInDollars = totalValue / 100;

    // MKQ tracking
    if (typeof mkq === 'function') {
      mkq('track', 'AddToCart', {
        value: totalValueInDollars.toString(),
        currency: 'USD',
        content_name: productTitle,
        content_ids: items.map(item => item.id.toString())
      });
          }

    // Google Analytics 4
    if (typeof gtag === 'function') {
      gtag('event', 'add_to_cart', {
        currency: 'USD',
        value: totalValueInDollars,
        items: itemsData
      });
          }

    // Facebook Pixel
    if (typeof fbq === 'function') {
      fbq('track', 'AddToCart', {
        content_ids: items.map(item => item.id.toString()),
        content_type: 'product',
        value: totalValueInDollars,
        currency: 'USD',
        num_items: totalQuantity
      });
          }

    // TikTok Pixel
    if (typeof ttq === 'function') {
      ttq.track('AddToCart', {
        content_type: 'product',
        content_id: mainProduct.id.toString(),
        content_name: productTitle,
        value: totalValueInDollars,
        currency: 'USD',
        quantity: totalQuantity
      });
    }

    const cartAddEvent = new CustomEvent('shopify:cart:add', {
      detail: {
        variantId: mainProduct.id.toString(),
        quantity: totalQuantity,
        items: items,
        source: 'upsell-function',
        hasUpsells: items.length > 1,
        hasFreeGifts: this.hasFreeGift()
      }
    });
    document.dispatchEvent(cartAddEvent);

    window.dispatchEvent(new CustomEvent('upsell:add_to_cart', {
      detail: {
        items: items,
        mainProduct: mainProduct,
        totalQuantity: totalQuantity,
        totalValue: totalValueInDollars,
        hasUpsells: items.length > 1,
        hasFreeGifts: this.hasFreeGift(),
        timestamp: Date.now()
      }
    }));

    if (typeof window.dataLayer !== 'undefined') {
      window.dataLayer.push({
        event: 'add_to_cart_upsell',
        ecommerce: {
          currency: 'USD',
          value: totalValueInDollars,
          items: itemsData
        },
        custom_parameters: {
          has_upsells: items.length > 1,
          has_free_gifts: this.hasFreeGift(),
          total_items: totalQuantity
        }
      });
    }

          console.log('Upsell ATC Event:', {
      totalItems: items.length,
      totalQuantity: totalQuantity,
      totalValue: totalValueInDollars,
      hasUpsells: items.length > 1,
      hasFreeGifts: this.hasFreeGift()
    });
  }

  hasFreeGift() {
    const freeGiftWrapper = document.querySelector('.upsell-products-wrapper');
    if (!freeGiftWrapper) return false;
    
    const freeGiftProducts = freeGiftWrapper.getAttribute('data-free-gift-products');
    
    return !!(freeGiftProducts && freeGiftProducts.trim() !== '');
  }

  getFreeGiftData() {
    const freeGiftWrapper = document.querySelector('.upsell-products-wrapper');
    if (!freeGiftWrapper) return null;
    
    const freeGiftProducts = freeGiftWrapper.getAttribute('data-free-gift-products');
    
    if (!freeGiftProducts || freeGiftProducts.trim() === '') return null;
    
    const gifts = [];
    const productPairs = freeGiftProducts.split(',');
    
    productPairs.forEach(pair => {
      const trimmedPair = pair.trim();
      if (trimmedPair) {
        const [productId, variantId] = trimmedPair.split(':');
        if (productId && variantId && !isNaN(parseInt(productId)) && !isNaN(parseInt(variantId))) {
          gifts.push({
            productId: parseInt(productId.trim()),
            variantId: parseInt(variantId.trim())
          });
        }
      }
    });
    
    return gifts.length > 0 ? gifts : null;
  }

  showError(message) {
    const errorWrapper = document.querySelector('.product-form__error-message-wrapper');
    const errorMessage = document.querySelector('.product-form__error-message');
    
    if (errorWrapper && errorMessage) {
      errorMessage.textContent = message;
      errorWrapper.hidden = false;
    }
  }
}

// Initialize on DOM ready - prevent duplicate initialization
document.addEventListener('DOMContentLoaded', () => {
  if (window.productUpsellInitialized) {
    return;
  }
  
  window.productUpsellInitialized = true;
  new ProductUpsell();
}); 